// Подписи словаря правил на языке кабинета (`src/rules/vocab.py`).
//
// Слово приказа остаётся КЛЮЧОМ фильтра и адреса (`?sp=минтай`): ссылка,
// сделанная в русском кабинете, открывается в английском тем же отбором.
// Подпись — английское название словаря, а где его нет (вид Омана, новое слово
// до сторожа) — само слово: пустая строка на месте подписи хуже чужого языка.

import { t } from '../i18n'
import type { Lang } from '../i18n'

export interface Term {
  key: string
  en: string | null
}

export function termLabel(key: string | null, terms: Term[] | undefined, lang: Lang): string | null {
  if (key == null) return null
  if (lang === 'ru') return key
  return terms?.find(x => x.key === key)?.en ?? key
}

export interface RuleValue {
  number: number
  unit: string
  bound: string
  measure: string
  bound_code?: string | null
  unit_code?: string | null
}

/** «не менее 30 см» на языке кабинета. Коды — с сервера; без кода (старый
 *  ответ) — слова приказа, как раньше. */
export function valueText(v: RuleValue): string {
  const bound = v.bound_code ? t(`rules.bound.${v.bound_code}`) : v.bound
  const unit = v.unit_code ? t(`rules.unit.${v.unit_code}`) : v.unit
  return [bound, String(v.number), unit].filter(Boolean).join(' ')
}
